import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField';
import { PageTitle, PaperWithTitle, ButtonWithIcon, SecondaryButton, ImgFile } from '../../../components';
import { useClinicUser, useClinic, useMaster, useAuthUser } from '../../../../model/hooks';
import { Utils } from '../../../../common/helper';
import { getBillingPlanTypeLabel } from '../../../common/helper';
export const Account = () => {
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const { jobClinic, paymentClinic } = useClinicUser();
    const { loading, uploadProfileImage } = useClinic();
    const { applyClinicMaster } = useMaster();
    const { user } = useAuthUser();
    const [corporateName, setCorporateName] = useState('');
    const [facilityName, setFacilityName] = useState('');
    const [facilityDiv, setFacilityDiv] = useState('');
    const [tel, setTel] = useState('');
    const [prefecture, setPrefecture] = useState('');
    const [address, setAddress] = useState('');
    const [email, setEmail] = useState('');
    const [recruiterName, setRecruiterName] = useState('');
    const [profileImageUrl, setProfileImageUrl] = useState('');
    const [planName, setPlanName] = useState('');
    useEffect(() => {
        var _a;
        if (jobClinic === undefined)
            return;
        setCorporateName(jobClinic.corporateName || '');
        setFacilityName(jobClinic.clinicName || '');
        setFacilityDiv(jobClinic.facilityDivName(applyClinicMaster));
        setTel(jobClinic.tel || '');
        setPrefecture(jobClinic.prefectureName(applyClinicMaster));
        setRecruiterName(jobClinic.fullNamefRecruiter());
        setAddress(jobClinic.locationAddress || '');
        setPlanName(getBillingPlanTypeLabel((_a = paymentClinic) === null || _a === void 0 ? void 0 : _a.planType));
        if (Utils.isNotNull(jobClinic.image)) {
            setProfileImageUrl(jobClinic.image.url);
        }
        if (user !== undefined) {
            setEmail(user.email || '');
        }
    }, [jobClinic, paymentClinic, applyClinicMaster, user]);
    const onChangeRecruiterName = (e) => setRecruiterName(e.target.value);
    const onUploadProfileImage = async (file) => {
        try {
            console.log('upload', file);
            await uploadProfileImage(file);
        }
        catch (e) {
            reactAlert.error(t('アップロードに失敗しました。アップロードできるサイズは valueMバイト までです。', { value: 5 }));
        }
    };
    const onClickChangeMail = () => history.push('/home/account/change_mail');
    const onClickChangePass = () => history.push('/home/account/change_pass');
    const onClickChangePlan = () => history.push('/home/account/change_plan');
    const onClickChangeCreditCard = () => history.push('/home/account/change_creditcard');
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('アカウント情報')),
        React.createElement(SGrid, { container: true, justify: "center" },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement(PaperWithTitle, { title: "\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831", titleAlign: "center" },
                    React.createElement(SGrid, { container: true, spacing: 3, justify: "center" },
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(ImgFile, { type: 'avatar', img: {
                                    src: profileImageUrl,
                                    width: '160px',
                                    height: '160px',
                                    alt: 'プロフィール画像',
                                }, emptyIconSize: 64, loading: loading, onChange: (file, binary) => onUploadProfileImage(file) })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('契約者名'), value: corporateName, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('施設名'), value: facilityName, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('担当者名'), value: recruiterName, onChange: onChangeRecruiterName, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('施設区分'), value: facilityDiv, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('電話番号'), value: tel, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('都道府県'), value: prefecture, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 11 },
                            React.createElement(TextField, { required: true, label: t('所在地'), value: address, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 7 },
                            React.createElement(TextField, { required: true, label: t('メールアドレス'), value: email, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 4, style: { padding: 0 } },
                            React.createElement(SChangeButtonArea, null,
                                React.createElement(ButtonWithIcon, { text: "\u5909\u66F4\u3059\u308B", iconName: "chevron_right", iconPosition: "end", onClick: onClickChangeMail }))),
                        React.createElement(Grid, { item: true, xs: 7 },
                            React.createElement(TextField, { required: true, type: "password", label: t('パスワード'), value: 'password', fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 4, style: { padding: 0 } },
                            React.createElement(SChangeButtonArea, null,
                                React.createElement(ButtonWithIcon, { text: "\u5909\u66F4\u3059\u308B", iconName: "chevron_right", iconPosition: "end", onClick: onClickChangePass }))),
                        React.createElement(Grid, { item: true, xs: 7 },
                            React.createElement(TextField, { required: true, label: t('ご契約プラン'), value: planName, fullWidth: true, disabled: true })),
                        React.createElement(Grid, { item: true, xs: 4, style: { padding: 0 } },
                            React.createElement(SChangeButtonArea, null,
                                React.createElement(ButtonWithIcon, { text: "\u5909\u66F4\u3059\u308B", iconName: "chevron_right", iconPosition: "end", onClick: onClickChangePlan }))),
                        React.createElement(Grid, { item: true, xs: 8, style: { marginTop: '16px' } },
                            React.createElement(SecondaryButton, { fullWidth: true, onClick: onClickChangeCreditCard }, t('クレジットカード登録')))))))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SChangeButtonArea = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 24px;
`;
